import React from 'react';
import { Button } from 'antd';

const EventDropdownButton = ({ onClick, children }) => {
  return (
    <Button
      style={{
        padding: '0, 0',
        alignItems: 'center',
        justifyContent: 'center',
        width: '295px',
        height: '32px',
        border: '1px solid lightgray',
      }}
      onClick={onClick}
    >
      {children}
    </Button>
  );
};

export default EventDropdownButton;
